import Logger from './logger';
import {
  RESY_CREDIT_ELIGIBLE_ONLY,
  TABLE_AREA,
  VENUE_TYPE,
} from '../components/SearchFilterContainer/searchFilterConstants';

const VENUE_TYPE_ENUM = {
  restaurants: 'Restaurant',
  wineries: 'Winery',
};
const getSlotFilter = (date, partySize, time) => ({
  day: moment(date).format('YYYY-MM-DD'),
  party_size: +partySize,
  time_filter: time,
});

const getAutocompleteSearchPayload = (params, { includeTockInventory = false } = {}) => ({
  geo: {
    latitude: params.latitude,
    longitude: params.longitude,
  },
  highlight: {
    pre_tag: '<b>',
    post_tag: '</b>',
  },
  ...(includeTockInventory && { include_tock_inventory: true }),
  per_page: 5,
  query: params.value,
  slot_filter: getSlotFilter(params.selectedDate, params.selectedPartySize),
  types: ['venue', 'cuisine'],
});

const getAutocompleteCacheKey = (params) => {
  // eslint-disable-next-line camelcase
  const { query, geo, slot_filter } = getAutocompleteSearchPayload(params);
  return [
    query,
    slot_filter.day,
    slot_filter.party_size,
    geo.latitude,
    geo.longitude,
  ].join(':');
};

const getVenueSearchPayload = (params, { includeTockInventory = false } = {}) => {
  const INDOOR = 'Indoor';
  const payload = {
    availability: true,
    ...(includeTockInventory && { include_tock_inventory: true }),
    page: params.page,
    per_page: params.hitsPerPage,
    slot_filter: getSlotFilter(params.selectedDate, params.selectedPartySize, params.timeFilter),
    types: ['venue'],
    inventory: params.inventory,
    order_by: 'availability',
  };

  /**
     * Handle Geo Params
     * Either:
     * a) use bounding box
     * b) use coordinates + radius
     */
  if (params.boundingBox) {
    payload.geo = {
      bounding_box: params.boundingBox,
    };
  } else {
    payload.geo = {
      latitude: params.latitude,
      longitude: params.longitude,
      radius: params.radius,
    };
  }

  /**
   * Handle Venue Filter Params
   */
  if ('type' in params.query) {
    /* istanbul ignore else */
    if (params.query.type === 'query') {
      payload.query = params.query.value;
    } else if (params.query.type === 'facet') {
      const [facet, value] = params.query.value.split(':');
      if (facet === TABLE_AREA) {
        payload.slot_filter = { ...payload.slot_filter, [facet]: value };
        if (value !== INDOOR) {
          payload.per_page = 100;
        }
      } else if (facet === RESY_CREDIT_ELIGIBLE_ONLY) {
        payload.venue_filter = { resy_credit_eligible_only: true };
      } else if (facet === VENUE_TYPE) {
        payload.venue_filter = {
          ...payload.venue_filter,
          venue_type: VENUE_TYPE_ENUM[value],
        };
      } else {
        payload.venue_filter = { [facet]: value };
      }
    } else if (params.query.type === 'collection') {
      payload.venue_filter = {
        collection_slug: params.query.value,
        location_code: params.selectedLocationCode,
      };
    }
  } else {
    Logger.warn('[ERROR] getVenueSearchPayload: expected params.query to have "type" property and it did not');
  }

  return payload;
};

export {
  getAutocompleteCacheKey,
  getAutocompleteSearchPayload,
  getVenueSearchPayload,
};
